import classNames from 'classnames'
import { FC, ReactNode } from 'react'

import { ProgressBar } from 'partner360/components/qualityIndicator'

import styles from './KpiProgressBar.module.scss'

interface IKPIProgressBarProps {
  label: ReactNode
  value: number
  target: number
  className?: string
}

export const KpiProgressBar: FC<IKPIProgressBarProps> = ({ label, value, target, className }) => {
  const percent = target > 0 ? (value / target) * 100 : 0

  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.header}>
        <div>{label}</div>
        <div>{Math.round(percent)}%</div>
      </div>
      <ProgressBar value={value} target={target} />
    </div>
  )
}
